import axios, { gft_axios, normal_axios } from '@/utils/request'

import LocalData from '@/utils/local_data'

import { requestErrorLog, UserLog } from '@/utils/log'

import { FALLBACK_KEY } from '@/utils/wxafuzz'

import { App_User } from '@/data/user_info'
import Cookie from '@/utils/cookie'

const { VUE_APP_TYPE } = process.env

import { request } from 'fangchan-base'

const { LOGIN_STORE } = request

const { interceptors } = axios
const { interceptors: gft_interceptors } = gft_axios
const { interceptors: normal_interceptors } = normal_axios

const SessionStatus = {
    session_doing: false,
    _cb_list: [],
    addListener (cb) {
        this._cb_list.push(cb)
    },
    startSession () {
        this.session_doing = true
    },
    finishSession () {
        this.session_doing = false
        while (this._cb_list.length) {
            this._cb_list.shift()()
        }
    }
}

const SESSION_MAP = {
    'tft': {
        path: 'fc/sessions/tft_oauth',
        param_name: 'token'
    }
}


const { path: session_path, param_name: session_param_name } = SESSION_MAP[VUE_APP_TYPE]

export const resetToken = (token) => {
    console.error('token', token)
    Cookie.setItem('token', token, {
        sPath: '/'
    })
    initRequest(token)
    initGftRequest(token)
}

export const checkSessionStatus = () => {
    const token = Cookie.getItem('token')
    console.error('checkSessionStatus', token)
    if (token) {
        return Promise.resolve()
    }
    return session()
}

export const session = () => {
    return normal_axios.post(session_path).then(data => {
        if (data == 401) {
            reauth()
        } else {
            const { token, user, share_info, extension } = data
            console.log('session success', new Date().toLocaleString())
            if (share_info) {
                console.log('share_info:', share_info, new Date().toLocaleString())
            }
            if (data && token) {
                LocalData.user.set(user)
                UserLog.userLogin()
                resetToken(token)
            }
            if (VUE_APP_TYPE === 'tft') {
                if (extension && extension.jsapi_params) {
                    const { jsapi_params } = extension
                    tf.config({
                        appId: jsapi_params.appid,
                        timestamp: jsapi_params.timestamp,
                        signature: jsapi_params.signature,
                        jsApiList: ['photo'],
                        nonce: jsapi_params.nonce
                    }).then((data) => {
                        console.log('tf config success', data)
                    }).catch(err => {
                        console.error('tf config error', err, jsapi_params)
                    })
                }
            }
        }
        SessionStatus.finishSession()
    })
}

export const reauth = () => {
    if (LOGIN_STORE.doing) {
        return new Promise((res) => {
            LOGIN_STORE.wait(res)
        })
    }
    LOGIN_STORE.start()
    return session()
}

export const init = () => {
    const token = Cookie.getItem('token')
    if (token) {
        return Promise.resolve()
    }
    reauth()
    return Promise.reject()
}

const genInitRequest = (interceptors) =>
     (token) => interceptors.request.use(config => {
        config.headers['Authorization'] = token
        return config
    }, () => {}, (params) => {
        params.header['cache-control'] = 'no-store'
        return params
    })

const genInitResponse = (interceptors) =>
    (token_name) => interceptors.response.use(config => {
        return config
    }, (error, requestInfo) => {
        requestErrorLog(error, requestInfo)
        return Promise.reject(error)
    }, (res, requestInfo) => {
        console.log('res', res)
        const { data: respData, header, statusCode } = res
        const { meta, data } = respData
        const code = respData.meta ? respData.meta.code : statusCode
        console.log('code', code)
        if (code === FALLBACK_KEY.OPEN_CODE) {
            const fuzz_key = header['fuzz-fallback-key']
            FALLBACK_KEY.setKey(fuzz_key)
            console.error('FALLBACK_KEY set', fuzz_key)
            return FALLBACK_KEY.OPEN_CODE
        }
        if (code === FALLBACK_KEY.CLOSE_CODE) {
            FALLBACK_KEY.resetKey()
            return FALLBACK_KEY.CLOSE_CODE
        }
        if (code == 401) {
            Cookie.setItem(token_name, '', {
                sPath: '/'
            })
            App_User.setJscode('')
            return 401
        }
        if (code == 404 || code == 500) {
            return Number(code)
        }
        if (meta && meta.code === 422) {
            if (data && Object.keys(data).length) {
                return respData
            }
            return meta
        }
        if (data) {
            return data
        }
        return respData
    })

const initRequest = genInitRequest(interceptors)
const initResponse = genInitResponse(interceptors)

genInitResponse(normal_interceptors)('token')

const initGftRequest = genInitRequest(gft_interceptors)
const initGftResponse = genInitResponse(gft_interceptors)
initGftRequest(Cookie.getItem('token'))
initGftResponse('token')

initRequest(Cookie.getItem('token'))
initResponse('token')


const genMethod = (func, auto_reauth = false) => {
    return (...args) => {
        const promseFunc = () => func.apply(func, args)
        return promseFunc().then(data => {
            if (data === FALLBACK_KEY.OPEN_CODE || data === FALLBACK_KEY.CLOSE_CODE) {
                console.error('retry')
                return promseFunc()
            }
            if (data == 401) {
                return reauth().then(promseFunc)
            }
            if (data == 404) {
                requestErrorLog(404, args)
                throw data
            }
            if (data == 500) {
                requestErrorLog(500, args)
                throw data
            }
            return data
        })
    }
}

const genAPIMethod = (apiType, method) => {
    return (...args) => {
        args[0] = `${apiType}/${args[0]}`
        return method.apply(method, args)
    }
}

const getAxiosMethod = method => axios[method].bind(axios)

export const get = genMethod(getAxiosMethod('get'))
export const post = genMethod(getAxiosMethod('post'))
export const put = genMethod(getAxiosMethod('put'))
export const del = genMethod(getAxiosMethod('delete'))

const V1 = 'fc/v1'
const V2 = 'fc/v2'
const V3 = 'fc/v3'
const V4 = 'fc/v4'

const FC = 'fc'

export const getV1 = genAPIMethod(V1, get)
export const postV1 = genAPIMethod(V1, post)
export const putV1 = genAPIMethod(V1, put)
export const delV1 = genAPIMethod(V1, del)

export const getV2 = genAPIMethod(V2, get)
export const putV2 = genAPIMethod(V2, put)
export const postV2 = genAPIMethod(V2, post)

export const getFC = genAPIMethod(FC, get)
export const postFC = genAPIMethod(FC, post)
export const putFC = genAPIMethod(FC, put)
export const delFC = genAPIMethod(FC, del)

export const getV3 = genAPIMethod(V3, get)
export const postV3 = genAPIMethod(V3, post)

export const getV4 = genAPIMethod(V4, get)
export const postV4 = genAPIMethod(V4, post)

const getGFTAxiosMethod = method => gft_axios[method].bind(gft_axios)

export const getGFT = genMethod(getGFTAxiosMethod('get'))
export const postGFT = genMethod(getGFTAxiosMethod('post'))
export const putGFT = genMethod(getGFTAxiosMethod('put'))
export const delGFT = genMethod(getGFTAxiosMethod('delete'))